(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/location-name-input.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/location-name-input.js');

'use strict';

const {
  useState,
  useEffect,
  useCallback
} = React;
const {
  useAtom,
  useSetAtom
} = jotai;
const {
  lyckoplatsenNameAtom,
  shouldDisablePayButtonAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  Form,
  ControlGroup,
  Inputv2
} = svs.ui.reactForm;
const {
  getDefaultLocationName
} = svs.tur.lyckoplatsen.utils;
const validateInputName = text => {
  const hasRegexUnicodeSupport = new RegExp().unicode === false;
  const allowedCharactersRegex = /[A-Za-z0-9-_!°'" áéíóúýæþðåäöÁÉÍÓÚÝÆÞÐÅÄÖ]+/g;
  const allowedEmojisRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
  const allowedVariationSelectorsRegex = /[\uFE00-\uFE0F]/g;
  if (typeof text !== 'string') {
    throw Error('must be a string');
  }
  text = text.replace(allowedCharactersRegex, '');
  if (hasRegexUnicodeSupport) {
    text = text.replace(allowedEmojisRegex, '');
    text = text.replace(allowedVariationSelectorsRegex, '');
  }
  return {
    invalid: text.length > 0,
    text
  };
};
const calculateBytes = input => {
  const encoder = new TextEncoder();
  const byteLength = encoder.encode(input).length;
  return byteLength;
};
const validateByteInput = input => {
  const bytes = calculateBytes(input);
  if (bytes > 50) {
    return true;
  }
  return false;
};
const invalidInput = 'Tillåtna tecken är: A-ö 0-9 -_!°\'" och emojis';
const errorMaxMessage = 'Texten är för lång';
const maxAllowedInput = 32;
const validationHandler = value => {
  let errorMessage = '';
  const {
    invalid,
    text
  } = validateInputName(value);
  if (invalid) {
    errorMessage = "".concat(text, " \xE4r ej till\xE5tet, ").concat('', invalidInput);
  } else if (validateByteInput(value)) {
    errorMessage = 'För många tecken';
  } else if (value.length > maxAllowedInput) {
    errorMessage = "".concat(errorMaxMessage, " ").concat(value.length, "/").concat(maxAllowedInput);
  }
  return errorMessage;
};
const LocationNameInput = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const hasError = errorMessage.length > 0;
  const [lyckoplatsenName, setLyckoplatsenName] = useAtom(lyckoplatsenNameAtom);
  const setShouldDisablePayButton = useSetAtom(shouldDisablePayButtonAtom);
  const inputEl = document.querySelector('#lyckoplatsenName');
  const validateValue = useCallback(value => {
    const err = validationHandler(value);
    setErrorMessage(err);
    const hasNewError = err.length > 0;
    if (!hasNewError) {
      setShouldDisablePayButton(false);
    } else {
      setShouldDisablePayButton(true);
    }
  }, [setShouldDisablePayButton]);
  useEffect(() => {
    validateValue(lyckoplatsenName);
  }, [lyckoplatsenName, validateValue]);
  const handleChange = e => {
    const value = e.target.value;
    setLyckoplatsenName(value);
    validateValue(value);
  };
  const handleBlur = () => {
    if (lyckoplatsenName.trim().length === 0) {
      setLyckoplatsenName(getDefaultLocationName());
      setShouldDisablePayButton(false);
    }
  };
  const handleFocus = () => {
    inputEl.setSelectionRange(0, 0);
    if (lyckoplatsenName === getDefaultLocationName()) {
      setLyckoplatsenName('');
    }
  };
  const handleSubmit = e => {
    e.preventDefault();
  };
  const handleInputKeyDown = e => {
    if (e.key === 'Enter') {
      inputEl === null || inputEl === void 0 || inputEl.blur();
    }
  };
  return React.createElement(Form, {
    isVertical: true,
    onSubmit: handleSubmit
  }, React.createElement(ControlGroup, {
    v2: true,
    hasError: hasError,
    errorMessage: errorMessage,
    idForInput: "lyckoplatsenName"
  }, React.createElement(Inputv2, {
    autoComplete: "off",
    id: "lyckoplatsenName",
    label: "Namnge din lyckoplats",
    value: lyckoplatsenName,
    type: "text",
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: handleInputKeyDown
  })));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  LocationNameInput
});

 })(window);